/*
 * @Author: zhu.huijun
 * @Date: 2021-05-07 10:05:18
 * @Last Modified by: zhu.huijun
 * @Last Modified time: 2022-03-01 09:43:13
 */
import React, { useEffect, useState, useRef, forwardRef } from 'react';
import { i18n } from 'fishx';
import { get, isEmpty } from 'lodash';
import { connect } from 'react-redux';

import { Button, Input, Drawer } from '@whalecloud/fdx';
import { ActTypeObj } from '@/utils';
import CommonModal from '@/components/CommonModal';
import PortalCardList from '../PortalCardList';
import OfferAttributes from '../SubsOfferInfo/AttributeInfo/OfferAttributes';
import SubscriberAttributes from '../SubsOfferInfo/AttributeInfo/SubscriberAttributes';

import styles from './index.module.less';

const OffRefInput = forwardRef((props, ref) => <Input ref={ref} {...props} />);

const OfferFormItem = props => {
  const offerInput = useRef();
  const offerGroupRef = useRef();
  const subsAttrRef = useRef();

  const {
    loading,
    isDrawer = false,
    dataGroup = [],
    placeholder = i18n('COMMON_SELECT_ICON'),
    form,
    value = {}, // offerDetail
    onChange,
    modelKey,
    qrySalesRuleParams,
    addressId,
    dispatch,
    mainOfferCurrentDpp = {},
    ...preProps
  } = props;

  const [visible, setVisible] = useState(false); // 弹框显示
  const [currentOffer, setCurrentOffer] = useState({});
  const [curDetail, setCurDetail] = useState({});
  const [currentDpp, setCurrentDpp] = useState({});
  const [refAttrDtoList, setRefAttrDtoList] = useState([]);
  const [dppOfferList, setDppOfferList] = useState([]);
  const [offerDataGroup, setOfferDataGroup] = useState(dataGroup);

  useEffect(() => {
    if (!visible) {
      offerInput.current.blur();
    }
  }, [visible]);

  const handleSubmit = async () => {
    if (isEmpty(currentOffer)) {
      return;
    }
    let newOffer = { ...currentOffer };
    if (isDrawer) {
      const offerGroupInfo = await offerGroupRef.current.getOfferGroupInfo();
      // 将dpp构造进offerInstList
      const offerInstList = get(offerGroupInfo, 'offerInstList');
      if (modelKey === 'newConnection') {
        offerInstList.push({
          offerId: currentDpp.offerId,
          offerName: currentDpp.offerName,
          actType: ActTypeObj.ADD,
        });
      } else {
        offerInstList.push({
          offerId: currentDpp.offerId,
          operationType: ActTypeObj.ADD,
        });
      }
      const subsAttrs = await subsAttrRef.current.getAttributeInfo({}); // 订户属性
      newOffer = { ...newOffer, offerGroupInfo, ...subsAttrs };
    }
    setCurrentOffer(newOffer);
    onChange(newOffer);
    setVisible(false);
  };
  const handleOfferSelect = async offer => {
    setCurrentOffer(offer);
    if (isDrawer) {
      // 获取可选scheme过滤条件
      const salesRuleRefAttrList = await dispatch({
        type: 'selectPlan/qrySalesRuleRefAttr',
        payload: {
          subsId: qrySalesRuleParams.subsId,
          acctId: qrySalesRuleParams.acctId,
          addressId,
          subsEventId: qrySalesRuleParams.subsEventId,
        },
      });
      // 套餐销售条件加上SUBS_PLAN_CODE
      salesRuleRefAttrList.push({
        attrCode: 'SUBS_PLAN_CODE',
        attrValue: offer.subsPlanCode,
      });
      setRefAttrDtoList(salesRuleRefAttrList);
      // 查出default price plan
      const dppOfferDtoList = await dispatch({
        type: 'selectPlan/qryDppOfferList',
        payload: {
          refAttrDtoList: salesRuleRefAttrList,
          subsPlanId: offer.offerId,
          addressId,
        },
      });
      setDppOfferList(dppOfferDtoList);
      // 切换套餐后默认选中该套餐下第一条dpp
      // 需求变更: 选中优先级 1.combo套餐选中的   2.defaultFlag=Y   3. 第一条
      const degfaultSelectDpp =
        dppOfferDtoList.find(dpp => dpp.offerId === mainOfferCurrentDpp.offerId) ||
        dppOfferDtoList.find(dpp => dpp.defaultFlag === 'Y') ||
        dppOfferDtoList[0] ||
        {};
      setCurrentDpp(get(degfaultSelectDpp, 'offerDto') || {});
      changePlanPrice(offer, get(degfaultSelectDpp, 'offerDto') || {});
      await queryOfferDetail(salesRuleRefAttrList, offer, get(degfaultSelectDpp, 'offerDto') || {});
    }
  };

  // dpp改变后要重新查询OfferDetail
  const handleDppChange = async (dpp = {}) => {
    setCurrentDpp(dpp);
    changePlanPrice(currentOffer, dpp);
    await queryOfferDetail(refAttrDtoList, currentOffer, dpp);
  };

  // Plan Price的值取自dpp
  const changePlanPrice = (offer = {}, dpp = {}) => {
    const curOfferData = offerDataGroup.find(offerData => offerData.offerId === offer.offerId);
    curOfferData.displayRentPrice = dpp.disRentListPrice || '0.00';
  };

  // 查询个性资费、依赖产品、实物等
  const queryOfferDetail = async (refAttrDtoList, subsPlan, dpp) => {
    const { offerDetail } = await dispatch({
      type: 'selectPlan/qrySubsPlanDetailBsnl',
      payload: {
        subsPlanId: subsPlan.offerId,
        addressId,
        refAttrDtoList: [
          ...refAttrDtoList,
          {
            attrCode: 'DPP_OFFER_CODE',
            attrValue: dpp.offerCode,
          },
        ],
      },
    });
    setCurDetail(offerDetail);
  };

  return (
    <div>
      <OffRefInput
        ref={offerInput}
        value={value.offerName}
        placeholder={placeholder}
        autoComplete="off"
        onClick={() => setVisible(true)}
        suffix={<span className="iconfont2 iconsend" style={{ color: '#ABACB2' }} onClick={() => setVisible(true)} />}
        {...preProps}
      />
      {visible && !isDrawer && (
        <CommonModal
          modalOpts={{
            title: i18n('SELECT_OFFER_PLAN'),
            footer: [
              <Button onClick={() => setVisible(false)} key="COMMON_CANCEL">
                {i18n('COMMON_CANCEL')}
              </Button>,
              <Button type="primary" onClick={handleSubmit} key="COMMON_SUBMIT">
                {i18n('COMMON_SUBMIT')}
              </Button>,
            ],
            draggable: false,
            onCancel: () => setVisible(false),
            width: 1400,
            className: `threeColumnWrap ${styles.offerFormItemModal}`,
          }}
        >
          <div className={`blockWrap ${styles.offerList}`}>
            <PortalCardList
              cardKey="offerId"
              dataGroup={offerDataGroup}
              defaultCardId={value.offerId}
              onClick={handleOfferSelect}
            />
          </div>
        </CommonModal>
      )}
      {visible && isDrawer && (
        <Drawer
          title={i18n('SELECT_OFFER_PLAN')}
          visible
          placement="right"
          closable={false}
          onClose={() => setVisible(false)}
          width={1000}
          className={`threeColumnWrap ${styles.offerFormItemModal}`}
        >
          <div className={`blockWrap ${styles.offerDrawer}`}>
            <PortalCardList
              cardKey="offerId"
              dataGroup={offerDataGroup}
              defaultCardId={value.offerId}
              onClick={handleOfferSelect}
            />
            {!isEmpty(curDetail) && (
              <>
                <OfferAttributes
                  ref={offerGroupRef}
                  offerDetail={curDetail}
                  modelKey={modelKey}
                  isComboUnit={true}
                  currentDpp={currentDpp}
                  onDppChange={handleDppChange}
                  dppOfferList={dppOfferList}
                />
                <SubscriberAttributes ref={subsAttrRef} modelKey={modelKey} addressId={addressId} offerDetail={curDetail} />
              </>
            )}
          </div>
          <div className={styles.drawerBtns}>
            <Button onClick={() => setVisible(false)}>{i18n('COMMON_CANCEL')}</Button>
            <Button type="primary" loading={loading} onClick={handleSubmit}>
              {i18n('COMMON_SUBMIT')}
            </Button>
          </div>
        </Drawer>
      )}
    </div>
  );
};

export default connect(state => ({
  loading: state.loading.effects['selectPlan/qrySubsPlanDetailBsnl'] || false,
}))(OfferFormItem);
